<template>
    <div class="user-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">{{$t('user.user')}}</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid">
                            <v-text-field
                                    v-model="form.attributes.firstname"
                                    :rules="nameRules"
                                    :counter="255"
                                    v-bind:label="$t('user.firstname')"
                                    required
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.attributes.name"
                                    :rules="nameRules"
                                    :counter="255"
                                    v-bind:label="$t('user.surname')"
                                    required
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.attributes.email"
                                    :rules="emailRules"
                                    :counter="255"
                                    v-bind:label="$t('user.email')"
                                    required
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.attributes.password"
                                    :counter="255"
                                    v-bind:label="$t('user.password')"
                                    required
                            ></v-text-field>

                            <v-autocomplete
                                    v-model="form.relationships['departments'].data"
                                    :items="departments"
                                    chips
                                    v-bind:label="$t('user.department')"
                                    item-text="attributes.title"
                                    item-value="id"
                                    multiple
                                    return-object
                            ></v-autocomplete>

                            <v-autocomplete
                                    v-model="form.relationships['roles'].data"
                                    :items="roles"
                                    chips
                                    v-bind:label="$t('user.roles')"
                                    item-text="attributes.name"
                                    item-value="id"
                                    multiple
                                    return-object
                            ></v-autocomplete>

                            <v-btn color="primary" @click="saveAction">
                                {{$t('message.save')}}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {

            this.$store.dispatch('departments/loadAll').then(() => {
                const widgets = this.$store.getters['departments/all'];
                widgets.forEach((item) => {
                    this.departments.push(item);
                });
            });

            this.$store.dispatch('roles/loadAll').then(() => {
                const widgets = this.$store.getters['roles/all'];
                widgets.forEach((item) => {
                    this.roles.push(item);
                });
            });

            if (this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('users/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['users/byId']({id: this.id});
                    this.form.attributes = widget.attributes;
                    this.form.id = widget.id;
                    this.form.type = widget.type;
                    const parent = widget;
                    this.$store.dispatch('departments/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['departments/related']({parent});
                        this.form.relationships['departments'].data = [];
                        this.form.relationships['departments'].data = related;
                    });

                    this.$store.dispatch('roles/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['roles/related']({parent});
                        this.form.relationships['roles'].data = [];
                        this.form.relationships['roles'].data = related;
                    });

                });
            } else {

            }



        },
        methods: {
            ...mapActions({
                delete: 'users/delete',
            }),

            saveAction: function () {
                if (this.$route.params.id != null) {
                    //this.form.id = this.$route.params.id;
                    var widget = this.$store.getters['users/byId']({id: this.form.id});
                    widget = this.form;
                    //console.log(this.form);
                    widget.relationships['departments'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });

                    widget.relationships['roles'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });

                    this.$store.dispatch('users/update', widget).then(() => {
                         this.$router.back();
                    });
                } else {
                    var widget = this.form;

                    widget.relationships['departments'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });

                    if(widget.relationships['departments'].data[0] != undefined)
                        if(widget.relationships['departments'].data[0].type == undefined)
                            delete widget.relationships['departments'];

                    widget.relationships['roles'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });

                    if(widget.relationships['roles'].data[0].type == undefined)
                        delete widget.relationships['roles'];

                    this.$store.dispatch('users/create', widget).then(() => {
                         this.$router.back();
                    });
                }
            }

        },
        computed: {
            ...mapGetters({
                loading: "users/isLoading",
                error: "users/isError",
            }),
        },
        data: () => ({

            form: {
                attributes: {
                    title: '',
                    firstname: '',
                    name: '',
                    email: '',
                    password: '',
                },
                relationships: {
                    'departments': {data: []},
                    'roles': {data: []},
                },
            },

            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],
            departments: [],
            roles: [],
        })
    }
</script>
